import React, { useState, useCallback, useEffect } from "react";
import LoadingImage from "./assets/Loading.gif";
import { AiOutlineCloseCircle } from "react-icons/ai";
import HTTP_BASE_URL from "../constants/HttpConstants";
import { BsPersonCircle } from "react-icons/bs";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const SenderReceiverDetails = ({ close, id }) => {
  const navigate = useNavigate();
  const customertoken = localStorage.getItem("customertoken");
  // eslint-disable-next-line
  const [closePopup, setClosePopup] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputValues, setInputValues] = useState({});

  const toastrOptions = {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  const getFullDetails = useCallback(async () => {
    const myHeaders = new Headers();
    myHeaders.append("access-token", "508b1430-68f0-4b2f-9003-3c2a0eb2a54a");
    myHeaders.append("customertoken", customertoken);
    const formdata = new FormData();
    formdata.append("id", id);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    await fetch(HTTP_BASE_URL + "getBookingdetails", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.code === 0) {
          const bookingDetails = result.data;
          setInputValues((prevState) => ({
            ...prevState,
            consignor_name: bookingDetails
              ? bookingDetails?.name === "null" || !bookingDetails?.name
                ? ""
                : bookingDetails?.name
              : "",
            consignor_email: bookingDetails
              ? bookingDetails?.email === "null" || !bookingDetails?.email
                ? ""
                : bookingDetails?.email
              : "",
            consignor_mobile: bookingDetails
              ? bookingDetails?.mobile === "null" || !bookingDetails?.mobile
                ? ""
                : bookingDetails?.mobile
              : "",
            consigngee_name: bookingDetails
              ? bookingDetails?.name === "null" || !bookingDetails?.name
                ? ""
                : bookingDetails?.name
              : "",
            consigngee_mobile: bookingDetails
              ? bookingDetails?.mobile === "null" || !bookingDetails?.mobile
                ? ""
                : bookingDetails?.mobile
              : "",
          }));
          //   console.log('billingDetails', bookingDetails);
        } else {
          navigate("/");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [id, customertoken, navigate]);

  const getAddressList = useCallback(async () => {
    const fullData = new FormData();
    fullData.append("bookingid", id);
    try {
      await fetch(HTTP_BASE_URL + "getAddressList", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            // setInputValues(result.data)
            const addressType1 = result.data.filter(
              (item) => item.address_type === 1
            );
            const addressType2 = result.data.filter(
              (item) => item.address_type === 2
            );
            // const addressType3 = result.data.filter(item => item.address_type === 3);
            if (
              (addressType1 && addressType1.length > 0) ||
              (addressType2 && addressType2.length > 0)
            ) {
              setInputValues({
                // ...result.data,
                // addressType1,
                // addressType2,
                // addressType3,
                consignor_name: addressType1[0]?.name || "",
                consignor_email: addressType1[0]?.email || "",
                consignor_mobile: addressType1[0]?.mobile || "",
                consignor_phone2: addressType1[0]?.mobile2 || "",
                consignor_address_line1: addressType1[0].address_line1 || "",
                consignor_address_line2: addressType1[0].address_line2 || "",
                consignor_city: addressType1[0].city || "",
                consignor_state: addressType1[0].state || "",
                consignor_country: addressType1[0].country || "",
                consignor_pincode: addressType1[0].pincode || "",
                consignor_landmark: addressType1[0].landmark || "",
                consigngee_name: addressType2[0].name || "",
                consigngee_mobile: addressType2[0].mobile || "",
                consigngee_phone2: addressType2[0].mobile2 || "",
                consigngee_address_line1: addressType2[0].address_line1 || "",
                consigngee_address_line2: addressType2[0].address_line2 || "",
                consigngee_city: addressType2[0].city || "",
                consigngee_state: addressType2[0].state || "",
                consigngee_country: addressType2[0].country || "",
                consigngee_pincode: addressType2[0].pincode || "",
                consigngee_landmark: addressType2[0].landmark || "",
              });
            } else {
              console.warn("No Sender & Receiver Address.");
            }
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      // setError(error); // Store any errors in the state
      console.error("Error:", error);
    }
  }, [id, customertoken, navigate]);

  const tokenExpiry = useCallback(() => {
    if (!customertoken) {
      // Step 1: Clear storage
      localStorage.clear(); // or sessionStorage.clear();
      // Step 2: Redirect to login or home page
      navigate("/", { replace: true });
      // Step 3: Prevent going back to the previous page
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = () => {
        window.history.pushState(null, "", window.location.href);
      };
    }
  }, [customertoken, navigate]);

  useEffect(() => {
    getFullDetails();
    getAddressList();
    tokenExpiry();
  }, [getFullDetails, getAddressList, tokenExpiry]);

  const handleOnChange = (e) => {
    const { name, value, checked, type } = e.target;
    setInputValues({
      ...inputValues,
      [name]: type === "checkbox" ? checked : value,
    });
    const error = validateField(name, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "consignor_name":
      case "consigngee_name":
        if (!value) {
          error = "This field is required.";
        } else if (value.length < 2) {
          error = "Please enter at least 2 characters.";
          // } else if (!/^[a-zA-Z\s\.\-]+$/.test(value)) {
          //     error = "Please enter letters, spaces, hyphens, and periods only.";
          // }
        } else if (!/^[a-zA-Z\s.-]+$/.test(value)) {
          error = "Only letters, spaces, hyphens, and periods are allowed.";
        }
        break;
      case "consignor_email":
        if (!value) {
          error = "";
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = "Invalid email address.";
        }
        break;

      case "consignor_mobile":
      case "consigngee_mobile":
        if (!value) {
          error = "This field is required.";
        } else if (!/^[0-9]{10}$/.test(value)) {
          error = "Mobile number must be exactly 10 digits.";
        } else if (value.length > 10) {
          error = "Please enter no more than 10 characters.";
        } else if (value.length < 10) {
          error = "Please enter at least 10 characters.";
        }
        break;
      case "consignor_phone2":
      case "consigngee_phone2":
        if (!value) {
          error = "";
        } else if (!/^[0-9]{10}$/.test(value)) {
          error = "Mobile number must be exactly 10 digits.";
        } else if (value.length > 10) {
          error = "Please enter no more than 10 characters.";
        } else if (value.length < 10) {
          error = "Please enter at least 10 characters.";
        }
        break;
      case "consignor_address_line1":
      case "consignor_address_line2":
      case "consigngee_address_line1":
      case "consigngee_address_line2":
        if (!value) {
          error = "This field is required.";
        } else if (value.length < 2) {
          error = "Please enter at least 2 characters.";
          // } else if (!/^[a-zA-Z\s\.\-]+$/.test(value)) {
          //     error = "Please enter letters, spaces, hyphens, and periods only.";
          // }
        } else if (!/^[a-zA-Z0-9\s,-]+$/.test(value)) {
          error =
            "Only letters, numbers, spaces, hyphens, and commas are allowed.";
        }
        break;
      case "consignor_city":
      case "consignor_state":
      case "consignor_country":
      case "consigngee_city":
      case "consigngee_state":
      case "consigngee_country":
        if (!value) {
          error = "This field is required.";
        } else if (value.length < 2) {
          error = "Please enter at least 2 characters.";
          // } else if (!/^[a-zA-Z\s\.\-]+$/.test(value)) {
          //     error = "Please enter letters, spaces, hyphens, and periods only.";
          // }
        } else if (!/^[a-zA-Z\s-]+$/.test(value)) {
          error = "Only letters, spaces, and hyphens are allowed.";
        }
        break;
      case "consigngee_pincode":
      case "consignor_pincode":
        if (!value) {
          error = "";
        } else if (!/^[0-9]{6}$/.test(value)) {
          error = "Please enter exactly 6 digits.";
        }
        break;
      case "consignor_landmark":
      case "consigngee_landmark":
        if (!value) {
          error = "";
        } else if (!/^[a-zA-Z0-9\s,-]+$/.test(value)) {
          error =
            "Only letters, numbers, spaces, hyphens, and commas are allowed.";
        }
        break;
      default:
        break;
    }
    return error;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const newErrors = {};

    // // Validate fields and collect errors
    Object.keys(inputValues).forEach((fieldName) => {
      const error = validateField(fieldName, inputValues[fieldName]);
      if (error) newErrors[fieldName] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      // alert('Please fill in all fields correctly');
      toast.warning("Please ensure all fields are filled in correctly.", {
        toastrOptions,
      });
      return;
    }

    setErrors(newErrors);
    // // Check if there are no errors
    if (Object.keys(newErrors).length === 0) {
      setIsSubmitting(true); // Show loading spinner

      // Handle payment type-specific logic
      let updatedValues = { ...inputValues };

      const formData = new FormData();
      formData.append("bookingid", id);

      Object.keys(updatedValues).forEach((key) => {
        formData.append(key, updatedValues[key]);
      });
      // console.log('formData', formData)
      try {
        // Simulate delay for spinner demo
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Submit the form data via API
        const response = await fetch(HTTP_BASE_URL + "saveConsignAddress", {
          method: "post",
          headers: {
            "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
            customertoken: customertoken,
          },
          body: formData,
        });

        const result = await response.json();

        // Handle API response
        if (result.code === 0) {
          //  console.log("Form submitted successfully:", result);
          setIsSubmitted(true);
          toast.success("Sender and receiver details saved successfully!", {
            toastrOptions,
          });
          setTimeout(function () {
            window.location.reload();
            setClosePopup(close);
          }, 1500);
        } else if (result.code === 1) {
          toast.error("Please fill in all required fields correctly", {
            toastrOptions,
          });
        } else {
          console.error("API error:", result);
          // alert("Failed to submit the form. Please try again.");
        }
      } catch (error) {
        console.error("Submission failed:", error);
        // alert("An error occurred. Please try again.");
      } finally {
        setIsSubmitting(false); // Hide loading spinner
      }
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {inputValues && (
        <div className="model fromModel">
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header p-0 border-none">
                <div className="modal-title">
                  {/* <span>hello </span> */}
                  {/* <span className='modal-title'>{inputValues.name || ''},</span> */}
                </div>
                <div className="btn-close" onClick={() => close(false)}>
                  <AiOutlineCloseCircle />
                </div>
              </div>
              {/* <p className='form-para mb-0'> Please fill out your car details to ease the process</p> */}
              <div className="modal-body">
                <p className="h5-title mt-3 icons ">
                  <BsPersonCircle style={{ marginBottom: "6px" }} /> Sender
                  Details
                </p>
                <form onSubmit={handleSubmit} autoComplete="off">
                  <div className="row form-row m-0">
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consignor_name" className="form-label">
                        Sender Name <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        id="consignor_name"
                        name="consignor_name"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_name || ""}
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Enter Sender Name"
                      />
                      {errors.consignor_name && (
                        <p className="text-para red">{errors.consignor_name}</p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consignor_email" className="form-label">
                        Email
                      </label>
                      <input
                        type="consignor_email"
                        name="consignor_email"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_email || ""}
                        id="consignor_email"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Enter@youremail.com"
                      />
                      {errors.consignor_email && (
                        <p className="text-para red">
                          {errors.consignor_email}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consignor_mobile" className="form-label">
                        Mobile <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consignor_mobile"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_mobile || ""}
                        id="consignor_mobile"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Mobile no- we don’t SPAM"
                      />
                      {errors.consignor_mobile && (
                        <p className="text-para red">
                          {errors.consignor_mobile}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consignor_phone2" className="form-label">
                        Secondary Mobile
                      </label>
                      <input
                        type="text"
                        name="consignor_phone2"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_phone2 || ""}
                        id="consignor_phone2"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Mobile no- we don’t SPAM"
                      />
                      {errors.consignor_phone2 && (
                        <p className="text-para red">
                          {errors.consignor_phone2}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label
                        htmlFor="consignor_address_line1"
                        className="form-label"
                      >
                        Address Line 1 <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consignor_address_line1"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_address_line1 || ""}
                        id="consignor_address_line1"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Eg: H3, Main Road"
                      />
                      {errors.consignor_address_line1 && (
                        <p className="text-para red">
                          {errors.consignor_address_line1}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label
                        htmlFor="consignor_address_line2"
                        className="form-label"
                      >
                        Address Line 2 <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consignor_address_line2"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_address_line2 || ""}
                        id="consignor_address_line2"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Address Line 2"
                      />
                      {errors.consignor_address_line2 && (
                        <p className="text-para red">
                          {errors.consignor_address_line2}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label
                        htmlFor="consignor_landmark"
                        className="form-label"
                      >
                        Landmark
                      </label>
                      <input
                        type="text"
                        name="consignor_landmark"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_landmark || ""}
                        id="consignor_landmark"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Landmark"
                      />
                      {errors.consignor_landmark && (
                        <p className="text-para red">
                          {errors.consignor_landmark}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consignor_city" className="form-label">
                        City <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consignor_city"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_city || ""}
                        id="consignor_city"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Eg: Jam Nagar"
                      />
                      {errors.consignor_city && (
                        <p className="text-para red">{errors.consignor_city}</p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consignor_state" className="form-label">
                        State <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consignor_state"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_state || ""}
                        id="consignor_state"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Eg: Delhi"
                      />
                      {errors.consignor_state && (
                        <p className="text-para red">
                          {errors.consignor_state}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consignor_country" className="form-label">
                        Country <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consignor_country"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_country || ""}
                        id="consignor_country"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder=" Eg: India"
                      />
                      {errors.consignor_country && (
                        <p className="text-para red">
                          {errors.consignor_country}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consignor_pincode" className="form-label">
                        Pincode
                      </label>
                      <input
                        type="text"
                        name="consignor_pincode"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consignor_pincode || ""}
                        id="consignor_pincode"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Eg: 100001"
                      />
                      {errors.consignor_pincode && (
                        <p className="text-para red">
                          {errors.consignor_pincode}
                        </p>
                      )}
                    </div>
                  </div>

                  <p className="h5-title pt-lg-5 pt-4 ">
                    <BsPersonCircle style={{ marginBottom: "6px" }} />
                    Receiver Details
                  </p>
                  <div className="row form-row m-0">
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consigngee_name" className="form-label">
                        Receiver Name <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        id="consigngee_name"
                        name="consigngee_name"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consigngee_name || ""}
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Enter Receiver Name"
                      />
                      {errors.consigngee_name && (
                        <p className="text-para red">
                          {errors.consigngee_name}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consigngee_mobile" className="form-label">
                        Mobile <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consigngee_mobile"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consigngee_mobile || ""}
                        id="consigngee_mobile"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Mobile no- we don’t SPAM"
                      />
                      {errors.consigngee_mobile && (
                        <p className="text-para red">
                          {errors.consigngee_mobile}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consigngee_phone2" className="form-label">
                        Secondary Mobile
                      </label>
                      <input
                        type="text"
                        name="consigngee_phone2"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consigngee_phone2 || ""}
                        id="consigngee_phone2"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Mobile no- we don’t SPAM"
                      />
                      {errors.consigngee_phone2 && (
                        <p className="text-para red">
                          {errors.consigngee_phone2}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label
                        htmlFor="consigngee_address_line1"
                        className="form-label"
                      >
                        Address Line 1 <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consigngee_address_line1"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consigngee_address_line1 || ""}
                        id="consigngee_address_line1"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Eg: H3, Main Road"
                      />
                      {errors.consigngee_address_line1 && (
                        <p className="text-para red">
                          {errors.consigngee_address_line1}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label
                        htmlFor="consigngee_address_line2"
                        className="form-label"
                      >
                        Address Line 2 <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consigngee_address_line2"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consigngee_address_line2 || ""}
                        id="consigngee_address_line2"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Address Line 2"
                      />
                      {errors.consigngee_address_line2 && (
                        <p className="text-para red">
                          {errors.consigngee_address_line2}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label
                        htmlFor="consigngee_landmark"
                        className="form-label"
                      >
                        Landmark
                      </label>
                      <input
                        type="text"
                        name="consigngee_landmark"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consigngee_landmark || ""}
                        id="consigngee_landmark"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Landmark"
                      />
                      {errors.consigngee_landmark && (
                        <p className="text-para red">
                          {errors.consigngee_landmark}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consigngee_city" className="form-label">
                        City <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consigngee_city"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consigngee_city || ""}
                        id="consigngee_city"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Eg: Jam Nagar"
                      />
                      {errors.consigngee_city && (
                        <p className="text-para red">
                          {errors.consigngee_city}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label htmlFor="consigngee_state" className="form-label">
                        State <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consigngee_state"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consigngee_state || ""}
                        id="consigngee_state"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Eg: Delhi"
                      />
                      {errors.consigngee_state && (
                        <p className="text-para red">
                          {errors.consigngee_state}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label
                        htmlFor="consigngee_country"
                        className="form-label"
                      >
                        Country <span className="req-span">*</span>
                      </label>
                      <input
                        type="text"
                        name="consigngee_country"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consigngee_country || ""}
                        id="consigngee_country"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder=" Eg: India"
                      />
                      {errors.consigngee_country && (
                        <p className="text-para red">
                          {errors.consigngee_country}
                        </p>
                      )}
                    </div>
                    <div className="col form-col col-md-4 col-12">
                      <label
                        htmlFor="consigngee_pincode"
                        className="form-label"
                      >
                        Pincode
                      </label>
                      <input
                        type="text"
                        name="consigngee_pincode"
                        disabled={isSubmitting || isSubmitted}
                        value={inputValues?.consigngee_pincode || ""}
                        id="consigngee_pincode"
                        onChange={handleOnChange}
                        className="form-control"
                        placeholder="Eg: 100001"
                      />
                      {errors.consigngee_pincode && (
                        <p className="text-para red">
                          {errors.consigngee_pincode}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="modal-footer pt-lg-5 pt-4 pb-2 text-center">
                    <button
                      type="submit"
                      className="submit-btn"
                      disabled={isSubmitting || isSubmitted}
                    >
                      {isSubmitting
                        ? "Submitting..."
                        : isSubmitted
                        ? "Submitted"
                        : "Submit"}
                      <span className="sub-loading">
                        {isSubmitting && (
                          <img
                            src={LoadingImage}
                            alt="Progress indicator"
                            width={25}
                            height={25}
                            loading="eager"
                          />
                        )}
                      </span>
                    </button>
                    {/* <div className="form-footer text-start">
                      <p className="form-para title-danger">
                        Documents Required
                      </p>
                      <p className="form-foot-text">
                        1. Valid copy of the vehicle's RC book and PAN Card of
                        the owner
                      </p>
                      <p className="form-foot-text">
                        2. Copy of the vehicle's insurance, with a minimum
                        validity of 15 days from the renewal date
                      </p>
                      <p className="form-foot-text">
                        3. Ensure the vehicle has a minimum of 25% fuel in the
                        fuel tank prior to transportation
                      </p>
                    </div> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SenderReceiverDetails;
